var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6562 9.88281C32.6562 10.5947 33.2334 11.1719 33.9453 11.1719H43.8281V40.1328C43.8281 42.2652 42.0933 44 39.9609 44H19.7448C23.0619 41.6647 25.3365 37.9448 25.722 33.6875H36.5234C37.2353 33.6875 37.8125 33.1103 37.8125 32.3984C37.8125 31.6865 37.2353 31.1094 36.5234 31.1094H25.722C25.5552 29.2673 25.0357 27.5254 24.2299 25.9531H36.5234C37.2353 25.9531 37.8125 25.376 37.8125 24.6641C37.8125 23.9522 37.2353 23.375 36.5234 23.375H22.5316C19.9286 20.2276 15.9954 18.2188 11.6016 18.2188C11.167 18.2188 10.7372 18.2395 10.3125 18.278V3.86719C10.3125 1.73482 12.0473 0 14.1797 0H32.6562V9.88281ZM17.6172 18.2188H36.5234C37.2353 18.2188 37.8125 17.6416 37.8125 16.9297C37.8125 16.2178 37.2353 15.6406 36.5234 15.6406H17.6172C16.9053 15.6406 16.3281 16.2178 16.3281 16.9297C16.3281 17.6416 16.9053 18.2188 17.6172 18.2188ZM35.2344 0.754703V8.59375H43.0728L35.2344 0.754703ZM11.6016 20.7969C5.20446 20.7969 0 26.0013 0 32.3984C0 38.7955 5.20446 44 11.6016 44C17.9987 44 23.2031 38.7955 23.2031 32.3984C23.2031 26.0013 17.9987 20.7969 11.6016 20.7969ZM15.0391 33.6875H11.6016C10.8897 33.6875 10.3125 33.1103 10.3125 32.3984V27.2422C10.3125 26.5303 10.8897 25.9531 11.6016 25.9531C12.3135 25.9531 12.8906 26.5303 12.8906 27.2422V31.1094H15.0391C15.751 31.1094 16.3281 31.6865 16.3281 32.3984C16.3281 33.1103 15.751 33.6875 15.0391 33.6875Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21C1E0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.361b1122847a80c12e232d1194c542ab.svg";
export { ForwardRef as ReactComponent };